import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Box, IconButton } from "@mui/material";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { tableConfig } from "../table/config/tableConfig";

const ProviderProvidedServiceTable = ({ loading, handleDelete, handleEdit }) => {
  const { data, isFetching } = useSelector((state) => state.providedServices.practices);
  const columns = useMemo(() => [
    {
      header: "ART",
      accessorKey: "art",
      enableColumnFilter: false
    },
    {
      header: "Razón Social",
      accessorKey: "razonSocial",
    },
    {
      header: "CUIT",
      accessorKey: "cuit",
    },
    {
      header: "Subnomenclatura",
      accessorKey: "nombreSubnomenclatura",
    },
    {
      header: "Prestación",
      accessorKey: "prestacion",
    },
    {
      header: "Nombre",
      accessorKey: "nombrePrestacion",
      minSize: 80,
      muiTableBodyCellProps: {
        sx: {
          whiteSpace: "normal",
          overflowWrap: "break-word",
        },
      },
    },
    {
      header: "Descripción",
      accessorKey: "descripcionPrestacion",
      minSize: 80,
      muiTableBodyCellProps: {
        sx: {
          whiteSpace: "normal",
          overflowWrap: "break-word",
        },
      },
    },
    {
      header: "Habilitada",
      accessorKey: "habilitada",
      filterVariant: "select",
      filterSelectOptions: [
        { text: "Sí", value: "si" },
        { text: "No", value: "no" },
      ],

      filterFn: (row, columnId, filterValue) => {
        if (!filterValue) return true;
        const cellValue = !!row.getValue(columnId);
        if (filterValue === "si") return cellValue === true;
        if (filterValue === "no") return cellValue === false;
        return true;
      },

      Cell: ({ row }) => {
        return row.original.habilitada ? "Sí" : "No";
      },
    },

  ], []);

  const table = useMaterialReactTable({
    ...tableConfig,
    columns: columns,
    data: data,
    defaultColumn: {
      maxSize: 80,
      minSize: 55,
      muiFilterTextFieldProps: {
        placeholder: '',
      },
    },
    layoutMode: "grid",
    state: { isLoading: loading || isFetching },
    positionActionsColumn: "last",
    enableRowActions: true,
    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>
        <IconButton
          onClick={() => {
            handleEdit(row.original);
          }}
        >
          <EditIcon />
        </IconButton>
        <IconButton
          color="error"
          onClick={() => {
            handleDelete(row.original);
          }}
        >
          <DeleteIcon />
        </IconButton>
      </Box >
    ),
  });

  return (
    <div>
      <MaterialReactTable table={table} />
    </div>
  );
};

export default ProviderProvidedServiceTable;